import { Box } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useAppStore } from "../store";
import DebugStoreDisplay from "./DebugStoreDisplay";

/**
 * Component that wraps the DebugStoreDisplay and ensures it appears on all pages
 * when debug mode is enabled
 */
const DebugStoreWrapper = () => {
  const debugMode = useAppStore((state) => state.debugMode);
  const location = useLocation();

  // Generate a unique key for the component using useMemo
  const uniqueKey = useMemo(() => `debug-store-${Date.now()}`, []);

  // Re-render when location changes to ensure it shows on every page
  useEffect(() => {
    // This effect ensures the component re-renders on route changes
  }, [location]);

  if (!debugMode) {
    return null;
  }

  return (
    <Box position="fixed" top="20px" right="20px" zIndex={9999} width="90%" maxWidth="500px" boxShadow="lg">
      <DebugStoreDisplay key={uniqueKey} position="default" />
    </Box>
  );
};

export default DebugStoreWrapper;
